<template>
    <div class="app-container">
        <el-row type="flex" align="middle">
            <span v-text-lbl="'StatisticalCycle'" class="demonstration">统计周期：</span>
            <el-date-picker v-model="datevalue" type="daterange" :range-separator="$tx('common.to', '至')" :start-placeholder="$tx('clgl.tjbb.startTime', '开始日期')" :end-placeholder="$tx('clgl.tjbb.endTime', '结束日期')" value-format="yyyy-MM-dd" @change="getDateArr" />
            <el-button v-pageBtn-lbl="'Statistics'" style="margin-left: 10px" type="primary" @click="getData">统计</el-button>
        </el-row>
        <div style="text-align: center; margin: 20px 0px 10px 0px">
            <span v-text-lbl="'DriverTrip'" class="statistics_title" style="text-align: center">司机出车统计</span>
        </div>
        <div class="echart">
            <EchartColumnar :top="'15%'" :y-unit="yunit" :left="'50'" :x-unit="xunit" :right="'100'" :x-data="xData" :y-data="yData" :x-label-rotate="45" />
        </div>
        <div>
            <data-table ref="dataTable" :list-tb="listTb" :list-data="listData" :show-summary="true" :file-name="fileName" />
        </div>
    </div>
</template>

<script>
import dataTable from './components/ListTable'
const moment = require('moment')
export default {
    components: {
        dataTable
    },
    data() {
        return {
            i18npkg: 'clgl',
            moduleCode: 'tjbb',
            xunit: { name: this.$tx('clgl.tjbb.DriverName', '司机名称'), align: 'end', size: '12' },
            yunit: { name: this.$tx('clgl.tjbb.frequency', '次数'), align: 'end', size: '12', lineColor: '#000' },
            listTb: [
                {
                    listAdvSearchElement: 'input',
                    prop: 'driverName',
                    title: this.$tx('clgl.tjbb.fields.driverName', '姓名'),
                    width: '80px',
                    align: 'center'
                },
                {
                    listAdvSearchElement: 'input',
                    prop: 'driverPhone',
                    title: this.$tx('clgl.tjbb.fields.driverPhone', '电话'),
                    width: '110px',
                    align: 'center'
                },
                {
                    listAdvSearchElement: 'input',
                    prop: 'driverNumber',
                    title: this.$tx('clgl.tjbb.fields.driverNumber', '驾驶证号'),
                    align: 'left'
                },
                {
                    listAdvSearchElement: 'input',
                    prop: 'drivingAge',
                    title: this.$tx('clgl.tjbb.fields.drivingAge', '司机驾龄'),
                    width: '100px',
                    align: 'center'
                },
                {
                    listAdvSearchElement: 'select',
                    prop: 'driverType',
                    title: this.$tx('clgl.tjbb.fields.driverType', '驾驶证类别'),
                    width: '100px',
                    align: 'center'
                    // formatter: (row, column, cellValue, index) => {
                    //     const obj = {
                    //         A1: '大型客车',
                    //         A2: '牵引车',
                    //         A3: '城市公交车',
                    //         B1: '中型客车',
                    //         B2: '大型货车',
                    //         C1: '小型汽车',
                    //         C2: '小型自动挡汽车',
                    //         C3: '低速载货汽车'
                    //     }
                    //     return obj[row.driverType]
                    // }
                },
                {
                    listAdvSearchElement: 'input',
                    prop: 'driverNum',
                    title: this.$tx('clgl.tjbb.fields.driverNum', '出车次数'),
                    width: '80px',
                    align: 'center'
                }
            ],
            listData: [],
            datevalue: ['', ''],
            xData: [],
            yData: [],
            fileName: '',
            xAxis: {
                splitLine: {
                    show: false
                }
            },
            yAxis: [
                {
                    // max:30,
                    min: 0,
                    type: 'value',
                    minInterval: 6,
                    interval: 6 // 每次增加几个
                }
            ]
        }
    },
    computed: {},
    created() {
        this.$bus.emit('showNavSearch', false) // 搜索去掉
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
        // document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'block'
    },
    mounted() {
        // document.querySelector('.dwyc').parentNode.parentNode.children[0].querySelector('.right-menu').style.display = 'none'
        const now = moment().format('YYYY-MM-DD')
        const tow = moment().add(-30, 'days').format('YYYY-MM-DD')
        this.datevalue = [tow, now]
        const nownow = moment().format('YYYY年MM月DD日')
        const towtow = moment().add(-30, 'days').format('YYYY年MM月DD日')
        this.fileName = this.$tx('clgl.tjbb.DriverUsage', { date1: towtow, date2: nownow })
        this.getData()
    },
    methods: {
        async getData() {
            // const param = {
            //     orderBy: 'carNumber asc',
            //     urlsearch: `orgCode:${this.loginUser.orgCode}`,
            //     startDate: this.datevalue[0] ? '' + this.datevalue[0] + ' 00:00:00' : '',
            //     endDate: this.datevalue[1] ? '' + this.datevalue[1] + ' 23:59:59' : ''
            // }
            // const res = await this.$app.listdata(`/clgl/clwx/getSjxxStatistics?startDate: this.datevalue[0] ? '' + this.datevalue[0] + ' 00:00:00' : ''`, param)
            this.$http({
                url: '/clgl/clxx/getSjxxStatistics',
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: this.datevalue[0] ? '' + this.datevalue[0] + ' 00:00:00' : '',
                    endDate: this.datevalue[1] ? '' + this.datevalue[1] + ' 23:59:59' : ''
                }
            }).then((res) => {
                if (res.code === 'success') {
                    this.listData = res.body.listdata
                    this.listData.length ? '' : (this.$refs['dataTable'].doing = false)
                    this.xData = []
                    this.yData = []
                    this.listData.forEach((args) => {
                        this.xData.push(args.driverName)
                        this.yData.push(args.driverNum)
                    })
                    this.yData = [this.yData]
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 更改时间
        getDateArr(data) {
            if (data) {
                this.datevalue = data
            } else {
                this.datevalue = ['', '']
            }
            // this.fileName = moment(data[0]).format('YYYY年MM月DD日') + '至' + moment(data[1]).format('YYYY年MM月DD日') + '司机出车统计'
            this.fileName = this.$tx('clgl.tjbb.DriverUsage', { date1: moment(data[0]).format('YYYY年MM月DD日'), date2: moment(data[1]).format('YYYY年MM月DD日') }, `${moment(data[0]).format('YYYY年MM月DD日')}至${moment(data[1]).format('YYYY年MM月DD日')}司机用车统计`)
        }
    }
}
</script>

<style scoped lang="scss">
.echart {
    height: 300px;
}
</style>
<style>
.dwyc .el-date-editor .el-range-separator {
    width: 6%;
}
</style>
